import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, NgModel, FormsModule, FormControl} from '@angular/forms';
import {  ImagePredictionFormDto, PredictResultServiceProxy, TestServiceProxy } from '@shared/service-proxies/service-proxies';
import { BehaviorSubject } from 'rxjs';


@Component({
  selector: 'kt-image-prediction',
  templateUrl: './image-prediction.component.html',
  styleUrls: ['./image-prediction.component.scss']
})
export class ImagePredictionComponent implements OnInit {

  vsForm: FormGroup;
  nesneAlgilamaFormDto: any; // ImagePredictionFormDto;
  //Bunun gibi bir base url belirtilmezse uygulamanın host katmanının bulunduğu yerde fotoğrafları arayacaktır.
  baseUrl = 'C:\\TestRaporlarKaynaklar\\TestPhotoBaseUrl\\';  
  filePath = '';

  comboValues = new BehaviorSubject<object>(null);
  isFormSubmitting = new BehaviorSubject<boolean>(false);
  isStackClear = new FormControl(true);
  // iterations = new BehaviorSubject<string[]>([]);
  // brands = new BehaviorSubject<string[]>([]);
  // epoches = new BehaviorSubject<string[]>([]);

  constructor(private _formBuilder: FormBuilder,
    private _predictResultServiceProxy: PredictResultServiceProxy,
    //private _testService :TestServiceProxy
  ) {
      this.vsForm = this._formBuilder.group(
        {
          urlValue: "",
          filePathValue: "",
          confidenceValue: "",
          gorevFormSonucKoduValue: "",
          projeTagValue: "",
          iterationValue: "",
          brandValue: "",
          epochValue: "",
        });
      
      this.nesneAlgilamaFormDto = new ImagePredictionFormDto();
      console.log(this.vsForm);
   }

  ngOnInit() {
    this._predictResultServiceProxy.getImgPredictionComboValues()
      .subscribe(result => {
      this.comboValues.next(result);
      console.log(result);
    }, (err)=> {
      console.log(err);
    })
    
  }

  test(){
    // this._predictResultServiceProxy.selamVer()
    //   .subscribe((result) => {
    //  // this.comboValues.next(res);
    //   console.log("Gelen",result);
    // }, (err)=> {
    //   console.log(err);
    // });


    
   
  }

  onFormSubmit()
  {
    //Burada API yazıldıktan sonra nswag ile service gelecek ve Dto gelecek Dto objesi içerisinde
    //formdan gelen dataları doldurup service'e parametre olarak vereck

    this.isFormSubmitting.next(true);

    const formValues = this.vsForm.value;
    const url = formValues.urlValue;
    const file = formValues.filePathValue;
    if (!url && !file) {
      alert("Bir URL adresi girmeli veya bir dosya seçmelisiniz.");      
    }
    if(this.vsForm.valid)
      {
        //Form'a girilen değerleri NesneAlgilamaFormDto türünden bir nesneye yerleştiriyoruz.

        this.nesneAlgilamaFormDto = new ImagePredictionFormDto({
          imageUrl: formValues.urlValue,
          filePath: this.filePath,
          confidenceValue: formValues.confidenceValue,
          gorevFormSonucKodu: formValues.gorevFormSonucKoduValue,
          projeTag: formValues.projeTagValue,
          iteration: formValues.iterationValue,
          brand: formValues.brandValue,
          epochValue: formValues.epochValue,
          isStackClear: this.isStackClear.value 
        });
        //console.log(this.nesneAlgilamaFormDto);
        
        //AppService'e bağlanıyoruz. Doldurduğumuz Dto nesnemizi veriyoruz. 
        try{
          this._predictResultServiceProxy.createImagePredictionResult(this.nesneAlgilamaFormDto).subscribe(
            response => {
             alert('Form başarılı olarak gönderildi.');

            },
            error => {
              alert('Form gönderilirken bir sorun ile karşılaşıldı.');
            }
          );
          
          this.isFormSubmitting.next(false);
        }
        catch (error){
           alert("AppService bağlantısında bir sorun ile karşılaşıldı.");
        }
      }
    else { alert('Zorunlu alanların doldurulması gerekiyor.'); } 

    this.isFormSubmitting.next(false);
  }


  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const reader = new FileReader();

      reader.onload = (e: any) => {
        const base64String = e.target.result.split(',')[1];
        this.filePath = base64String;
      };

      reader.readAsDataURL(file);
    }
  }

}
